import { render, staticRenderFns } from "./KategoriDuzenle.vue?vue&type=template&id=5dcecf89&scoped=true&"
import script from "./KategoriDuzenle.vue?vue&type=script&lang=js&"
export * from "./KategoriDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./KategoriDuzenle.vue?vue&type=style&index=0&id=5dcecf89&scoped=true&lang=css&"
import style1 from "./KategoriDuzenle.vue?vue&type=style&index=1&id=5dcecf89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcecf89",
  null
  
)

export default component.exports